module.exports = __webpack_public_path__ + "static/media/Angular-illustrations.6daa40d1.jpg";